import { ISearchConfig } from '@/components/page-search/types'

export const searchFormConfig: ISearchConfig = {
  formItems: [
    {
      type: 'input',
      label: '电话',
      placeholder: '请输入加盟者电话',
      field: 'phone'
    }
  ]
} 